import { render, staticRenderFns } from "./VBackButton.vue?vue&type=template&id=9f39c91c&scoped=true&"
import script from "./VBackButton.vue?vue&type=script&lang=ts&"
export * from "./VBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./VBackButton.vue?vue&type=style&index=0&id=9f39c91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f39c91c",
  null
  
)

export default component.exports